import { combineReducers } from 'redux'
import locator from './locator'
import store from './store'

export default combineReducers({
  locator,
  store
})



// WEBPACK FOOTER //
// ./src/reducers/index.js